import React, { useEffect, useRef, useState } from 'react';
import opsService from '../../../services/opsService';

const PILL = {
  parsing: 'bg-info-tint text-info',
  pending_review: 'bg-warning-tint text-warning',
  approved: 'bg-success-tint text-success',
  parse_failed: 'bg-danger-tint text-danger',
  disputed: 'bg-surface-sunken text-ink-soft',
};

export default function InvoiceList({ refreshKey, onOpen }) {
  const [rows, setRows] = useState([]);
  const timer = useRef(null);

  const load = async () => {
    try { setRows(await opsService.listInvoices()); } catch { /* keep prior rows */ }
  };

  const retry = async (id) => {
    try { await opsService.retryInvoice(id); load(); } catch { /* ignore; row stays failed */ }
  };

  const receive = async (id) => {
    try {
      await opsService.receiveInvoice(id);
      load();   // re-fetch rows (existing function in scope)
    } catch (e) {
      alert(e?.response?.data?.detail || 'Receive failed');
    }
  };

  useEffect(() => { load(); }, [refreshKey]);

  useEffect(() => {
    const anyParsing = rows.some((r) => r.status === 'parsing');
    if (anyParsing && !timer.current) {
      timer.current = setInterval(load, 3000);
    } else if (!anyParsing && timer.current) {
      clearInterval(timer.current); timer.current = null;
    }
    return () => { if (timer.current) { clearInterval(timer.current); timer.current = null; } };
  }, [rows]);

  return (
    <div className="bg-surface-card rounded-card shadow-elevation-1 border overflow-hidden">
      <table className="w-full text-small">
        <thead className="bg-surface-muted text-ink-muted">
          <tr>
            <th className="text-left px-4 py-2">Invoice #</th>
            <th className="text-left px-4 py-2">Total</th>
            <th className="text-left px-4 py-2">Status</th>
            <th className="px-4 py-2"></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-t">
              <td className="px-4 py-2 text-ink-soft">
                {r.invoice_number || '—'}
                {r.source === 'worldpac' && (
                  <span className="ml-2 px-2 py-0.5 rounded-full text-small bg-info-tint text-info">WorldPac</span>
                )}
              </td>
              <td className="px-4 py-2">{r.total != null ? `${r.currency} ${r.total}` : '—'}</td>
              <td className="px-4 py-2">
                <span className={`px-2 py-1 rounded-full text-small font-medium ${PILL[r.status] || 'bg-surface-sunken'}`}>
                  {r.status}
                </span>
              </td>
              <td className="px-4 py-2 text-right space-x-2">
                {r.status === 'parse_failed' && (
                  <button className="text-accent hover:underline" onClick={() => retry(r.id)}>Retry</button>
                )}
                {r.status === 'approved' && (
                  <button className="text-accent hover:underline" onClick={() => receive(r.id)}>Receive</button>
                )}
                <button className="text-accent hover:underline" onClick={() => onOpen(r.id)}>
                  {r.status === 'pending_review' ? 'Review' : 'Open'}
                </button>
              </td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan="4" className="px-4 py-6 text-center text-ink-muted">No invoices yet.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
